import React from 'react';

const Setting = props => {

    const classList = ['setting'];
    if (props.isActive) {
        classList.push('setting--active')
    }

    return (
        <div className={classList.join(' ')} onClick={props.clicked}>
            <div className="setting__icon"><i className={props.icon} aria-hidden="true"></i></div>
            <p className="setting__title">{props.title}</p>
        </div >
    );
}

export default Setting;